export default "__VITE_ASSET__B_nP7_LS__"